// extracted by mini-css-extract-plugin
module.exports = {"faq":"FAQ_faq__LoH9p","none":"FAQ_none__Ojfuc"};